/**
 * Copyright (C) 2023 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import { Box, Tab, Tabs } from '@mui/material';
import appTheme from '../../../../common/theme/appTheme.json';

export const CHART_TABS_HEIGHT_PX = 51;

interface ChartTabsProps {
  activeTab: string;
  setActiveTab: (tab: CHART_TAB_VALUES) => void;
}
export enum CHART_TAB_VALUES {
  PERFORMANCE = 'Performance',
  TRANSPORT_PLANS = 'Transport_plans',
}
export const ChartTabs = ({ activeTab, setActiveTab }: ChartTabsProps) => {
  const handleChange = (event: React.SyntheticEvent, tab: CHART_TAB_VALUES) => {
    setActiveTab(tab);
  };
  return (
    <Box sx={{ width: '100%', height: `${CHART_TABS_HEIGHT_PX}px`, bgcolor: appTheme.primaryBackgroundColor }}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        TabIndicatorProps={{
          sx: {
            backgroundColor: appTheme.mptLightBlue,
          },
        }}
      >
        <Tab
          value={CHART_TAB_VALUES.PERFORMANCE}
          label="Performance"
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            fontFamily: appTheme.appFontFamily,
            color: appTheme.secondaryHeaderTextColor,
            '&.Mui-selected': { color: appTheme.primaryTextColor },
          }}
        />
        <Tab
          value={CHART_TAB_VALUES.TRANSPORT_PLANS}
          label="Transport Plans"
          sx={{
            fontWeight: '400',
            fontSize: '15px',
            lineHeight: '24px',
            fontFamily: appTheme.appFontFamily,
            color: appTheme.secondaryHeaderTextColor,
            '&.Mui-selected': { color: appTheme.primaryTextColor },
          }}
        />
      </Tabs>
    </Box>
  );
};
